import { render, staticRenderFns } from "./RendicontazioneForm.vue?vue&type=template&id=84e5a060&"
import script from "./RendicontazioneForm.vue?vue&type=script&lang=js&"
export * from "./RendicontazioneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports